import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { register as registerServiceWorker } from './serviceWorker';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
import './index.css';
import App from './App';

const history = createBrowserHistory();

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [Sentry.reactRouterV4BrowserTracingIntegration({ history })],
	tracesSampleRate: 1.0
});

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
